import { useMemo, type PropsWithChildren } from 'react';

import {
  NotificationSettingsContext,
  type NotificationSettingsContextType,
} from '../contexts/NotificationSettingsContext.js';
import { useEventNotificationClient } from '../hooks/useEventNotificationClient.js';
import type {
  NotificationSettingsConfig,
  NotificationSettingsEventNotification,
} from '../NotificationSettings.js';

/** @internal */
export function EventNotificationClient(
  props: PropsWithChildren<
    Pick<NotificationSettingsEventNotification, 'config'>
  >,
) {
  const {
    toggleNotifications,
    loading,
    hasNotFoundError,
    hasReadPermission,
    hasWritePermission,
    enabled,
  } = useEventNotificationClient(props.config);

  const contextValue = useMemo<NotificationSettingsContextType>(
    () => ({
      enabled,
      hasNotFoundError,
      hasReadPermission,
      hasWritePermission,
      loading,
      toggleNotifications,
    }),
    [
      enabled,
      hasNotFoundError,
      hasReadPermission,
      hasWritePermission,
      loading,
      toggleNotifications,
    ],
  );

  return (
    <NotificationSettingsContext.Provider value={contextValue}>
      {props.children}
    </NotificationSettingsContext.Provider>
  );
}

/**
 * @internal
 */
export function isEventNotificationConfig(
  type: NotificationSettingsConfig['type'],
  config: NotificationSettingsConfig['config'],
): config is NotificationSettingsEventNotification['config'] {
  return type === 'event';
}
